import {Option, option} from "ts-option";
import AppointmentType from "../../model/appointment/AppointmentType";
import {store} from "../../navigation/ReduxProvider";
import Appointment from "../../model/appointment/Appointment";

/**
 * Get installer portal appointment.
 * @param leadId
 * @param {string} appointmentId installer portal appointment identifier.
 * @param state
 * @returns {Option<Appointment>} Installer portal appointment.
 */
export function getAppointment(leadId: string, appointmentId: string, state = store.getState()): Option<Appointment> {
	const appointments = state.appointment.appointments[leadId] || [];
	return option(appointments.filter((a) => a.id == appointmentId)[0]);
}

/**
 * Get appointment type.
 * @param {string} appointmentTypeId appointment type identifier.
 * @returns {Option<Appointment>} appointment type.
 */
export function getAppointmentType(appointmentTypeId: string): Option<AppointmentType> {
	return store.getState().appointment.appointmentTypes.flatMap(tab => option(tab.filter(at => at.id === appointmentTypeId)[0]));
}

/**
 * Get job appointment type.
 * @param {string} jobAppointmentTypeId job appointment type identifier.
 * @returns {Option<Appointment>} appointment type.
 */
export function getJobAppointmentType(jobAppointmentTypeId: string): Option<AppointmentType> {
	return store.getState().appointment.jobAppointmentTypes.flatMap(tab => option(tab.filter(at => at.id === jobAppointmentTypeId)[0]));
}
